import React from 'react';
import { RotateCcwIcon } from 'lucide-react';
import { Accent, SectionHeading } from './SectionHeading';
import { oldWay, prepFramework } from '../../data/content';

/** Section 13 — time vs. cost (no price, no button). */
export function TimeValueSection() {
  return <section aria-labelledby="time-heading" className="bg-brand-ivory px-5 py-16 lg:px-8 lg:py-24" data-id="element-234" data-mp="10wyf8cr78ybq">
      <div className="mx-auto max-w-5xl" data-id="element-235" data-mp="qwxv4oliae6h">
        <SectionHeading id="time-heading" title={<>
              What Is Your <Accent data-id="element-237" data-mp="m56bky0rp8pu">Preparation Time</Accent> Worth?
            </>} data-id="element-236" data-mp="qxzhvqbvwp41" />

        <div className="relative mt-12 grid gap-5 md:grid-cols-2 md:gap-8" data-id="element-238" data-mp="h6d2dhsik3vh">
          <div className="flex flex-col rounded-[22px] border border-brand-charcoal/10 bg-brand-paper/60 px-7 py-8 sm:px-9" data-id="element-239" data-mp="d5t4gc048w8a">
            <h3 className="font-body text-[12px] font-bold uppercase tracking-[0.2em] text-brand-charcoal/50" data-id="element-240" data-mp="85esiive924z">
              Keep Doing It the Old Way
            </h3>
            <ul className="mt-6 flex flex-wrap gap-2" role="list" data-id="element-241" data-mp="y09k0pwp249w">
              {oldWay.map(word => <li key={word} className="rounded-full border border-brand-charcoal/12 bg-white/70 px-4 py-1.5 font-body text-[14px] text-brand-charcoal/60" data-id="element-242" data-mp="12qhmworv6wo8">
                  {word}
                </li>)}
            </ul>
            <p className="mt-auto flex items-center gap-2 pt-8 font-display text-[1.35rem] italic text-brand-charcoal/55" data-id="element-243" data-mp="1ho0fk27nxu0y">
              <RotateCcwIcon className="h-4 w-4 flex-none" strokeWidth={1.5} aria-hidden="true" data-id="element-244" data-mp="1lpvi1a1bydgb" />
              Again. And again. And again.
            </p>
          </div>

          <span aria-hidden="true" className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-brand-charcoal font-display text-[1.1rem] font-bold italic text-brand-ivory md:absolute md:left-1/2 md:top-1/2 md:-translate-x-1/2 md:-translate-y-1/2" data-id="element-245" data-mp="1coxbajzibru1">
            vs.
          </span>

          <div className="flex flex-col rounded-[22px] border border-brand-cta/25 bg-white px-7 py-8 shadow-[0_30px_60px_-40px_rgba(72,103,70,0.55)] sm:px-9" data-id="element-246" data-mp="3dbyvnrfwzqk3">
            <h3 className="font-body text-[12px] font-bold uppercase tracking-[0.2em] text-brand-cta" data-id="element-247" data-mp="34kq9rgb1q42i">
              Brow Instructor Ready™
            </h3>
            <p className="mt-6 text-[15px] leading-relaxed text-brand-charcoal sm:text-[16px]" data-id="element-248" data-mp="2zl3wj6v7wntp">
              Start with a professional structure already organized to help you prepare and teach more
              efficiently.
            </p>
            <p className="mt-auto flex flex-wrap items-center gap-x-2 pt-8 font-display text-[1.5rem] font-bold text-brand-charcoal" data-id="element-249" data-mp="2lluhiaiqzzrb">
              {prepFramework.map((step, index) => <React.Fragment key={step} data-id="element-250" data-mp="2gp42lqioja7h" data-mpi={index}>
                  {index > 0 && <span aria-hidden="true" className="font-body text-[1rem] text-brand-gold" data-id="element-251" data-mp="jt6arr6wau6s">→</span>}
                  <span className={index === prepFramework.length - 1 ? 'italic text-brand-gold' : ''} data-id="element-252" data-mp="ewpkorg4y5r2">{step}</span>
                </React.Fragment>)}
            </p>
          </div>
        </div>

        <p className="mx-auto mt-12 max-w-xl text-center font-display text-[1.6rem] font-bold leading-snug text-brand-charcoal sm:text-[1.9rem]" data-id="element-253" data-mp="rcfjrjbhoqvb">
          So your next class doesn’t have to begin with <Accent data-id="element-254" data-mp="113a60noqjqgr">a blank page.</Accent>
        </p>
      </div>
    </section>;
}